import api from "./api";
import { getStoredUser, getStoredClientId } from "../utils/tokenUtils";

const base = () => ({
  client_id: getStoredClientId() || getStoredUser()?.client_id,
});

export const customizationService = {
  // ----- Test Case Types -----
  testCaseTypesList: async (projectId) => {
    const response = await api.post("api/customization/test-case-types/list", {
      ...base(),
      project_id: projectId,
    });
    return response.data;
  },
  testCaseTypesCreate: async (projectId, data) => {
    const response = await api.post(
      "api/customization/test-case-types/create",
      {
        ...base(),
        project_id: projectId,
        name: data.name,
        description: data.description,
        is_default: data.is_default,
      },
    );
    return response.data;
  },
  testCaseTypesUpdate: async (projectId, id, data) => {
    const response = await api.post(
      "api/customization/test-case-types/update",
      {
        ...base(),
        project_id: projectId,
        id,
        name: data.name,
        description: data.description,
        is_default: data.is_default,
      },
    );
    return response.data;
  },
  testCaseTypesReorder: async (projectId, orderedIds) => {
    const response = await api.post(
      "api/customization/test-case-types/reorder",
      {
        ...base(),
        project_id: projectId,
        ordered_ids: orderedIds,
      },
    );
    return response.data;
  },
  testCaseTypesDelete: async (projectId, id, remapToId) => {
    const response = await api.post(
      "api/customization/test-case-types/delete",
      {
        ...base(),
        project_id: projectId,
        id,
        remap_to_id: remapToId || undefined,
      },
    );
    return response.data;
  },

  // ----- Result Statuses -----
  resultStatusesList: async (projectId) => {
    const response = await api.post("api/customization/result-statuses/list", {
      ...base(),
      project_id: projectId,
    });
    return response.data;
  },
  resultStatusesCreate: async (projectId, data) => {
    const response = await api.post(
      "api/customization/result-statuses/create",
      {
        ...base(),
        project_id: projectId,
        name: data.name,
        code: data.code,
        color_hex: data.color_hex,
        is_default: data.is_default,
        is_final: data.is_final,
        ignored_in_metrics: data.ignored_in_metrics,
      },
    );
    return response.data;
  },
  resultStatusesUpdate: async (projectId, id, data) => {
    const response = await api.post(
      "api/customization/result-statuses/update",
      {
        ...base(),
        project_id: projectId,
        id,
        ...data,
      },
    );
    return response.data;
  },
  resultStatusesReorder: async (projectId, orderedIds) => {
    const response = await api.post(
      "api/customization/result-statuses/reorder",
      {
        ...base(),
        project_id: projectId,
        ordered_ids: orderedIds,
      },
    );
    return response.data;
  },
  resultStatusesDelete: async (projectId, id, remapToId) => {
    const response = await api.post(
      "api/customization/result-statuses/delete",
      {
        ...base(),
        project_id: projectId,
        id,
        remap_to_id: remapToId,
      },
    );
    return response.data;
  },

  // ----- Variables -----
  variablesList: async (filters = {}) => {
    const response = await api.post("api/customization/variables/list", {
      ...base(),
      ...filters,
    });
    return response.data;
  },
  variablesGet: async (id) => {
    const response = await api.post("api/customization/variables/get", {
      ...base(),
      id,
    });
    return response.data;
  },
  variablesCreate: async (data) => {
    const response = await api.post("api/customization/variables/create", {
      ...base(),
      name: data.name,
      scope: data.scope,
      project_id: data.project_id || null,
      value: data.value,
      is_secure: data.is_secure,
    });
    return response.data;
  },
  variablesUpdate: async (id, data) => {
    const response = await api.post("api/customization/variables/update", {
      ...base(),
      id,
      value: data.value,
      is_secure: data.is_secure,
    });
    return response.data;
  },
  variablesDelete: async (id) => {
    const response = await api.post("api/customization/variables/delete", {
      ...base(),
      id,
    });
    return response.data;
  },

  // ----- Result Fields -----
  resultFieldsList: async (filters = {}) => {
    const response = await api.post("api/customization/result-fields/list", {
      ...base(),
      ...filters,
    });
    return response.data;
  },
  resultFieldsGet: async (id) => {
    const response = await api.post("api/customization/result-fields/get", {
      ...base(),
      id,
    });
    return response.data;
  },
  resultFieldsCreate: async (data) => {
    const response = await api.post("api/customization/result-fields/create", {
      ...base(),
      name: data.name,
      type: data.type,
      description: data.description,
      is_required: data.is_required,
      is_system: data.is_system,
      project_id: data.project_id || null,
      options: data.options,
    });
    return response.data;
  },
  resultFieldsUpdate: async (id, data) => {
    const response = await api.post("api/customization/result-fields/update", {
      ...base(),
      id,
      name: data.name,
      type: data.type,
      description: data.description,
      is_required: data.is_required,
      options: data.options,
    });
    return response.data;
  },
  resultFieldsDelete: async (id) => {
    const response = await api.post("api/customization/result-fields/delete", {
      ...base(),
      id,
    });
    return response.data;
  },
};

export default customizationService;
